module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-password"
  }, [_c('el-col', {
    attrs: {
      "xs": {
        span: 20,
        offset: 1
      },
      "sm": {
        span: 12,
        offset: 6
      }
    }
  }, [_c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Reset your password")])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.formLoading),
      expression: "formLoading"
    }],
    ref: "resetForm",
    attrs: {
      "model": _vm.password,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    staticClass: "codeInput",
    attrs: {
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Reset Code"
    },
    model: {
      value: (_vm.password.code),
      callback: function($$v) {
        _vm.$set(_vm.password, "code", $$v)
      },
      expression: "password.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "New password"
    },
    model: {
      value: (_vm.password.pass),
      callback: function($$v) {
        _vm.$set(_vm.password, "pass", $$v)
      },
      expression: "password.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pass2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Confirm password"
    },
    model: {
      value: (_vm.password.pass2),
      callback: function($$v) {
        _vm.$set(_vm.password, "pass2", $$v)
      },
      expression: "password.pass2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('resetForm')
      }
    }
  }, [_vm._v("Reset password")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06bd910","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPassword.vue
// module id = 740
// module chunks = 18